// src/modules/app-views/companies/pages/Init/components/tableColumns/fullNameColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';
import { parseCnpjToDisplay, parseCpfToDisplay, parseNifToDisplay, parseNipcToDisplay, returnOnlyNumbers } from 'utils/helpers';

// *******************************************************************************
// HELPERS
// *******************************************************************************
function getFlagUrl(cc) {
  if (!cc) return null;
  const code = String(cc).toLowerCase();
  if (code.length !== 2) return null;
  const mapped = code === 'ac' ? 'gb' : code;
  return `https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.0.0/flags/4x3/${mapped}.svg`;
}

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function fullNameColumn(buildColumnProps, options = {}) {
  const {
    key = 'fullName',
    title = 'company_name',
    dataIndex = 'fullName',
    width,
    columnProps = { sort: true, search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    className: 'text-truncate',
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const cc = r?.countryCode;
      const flagSrc = cc ? getFlagUrl(cc) : null;

      let subtitle = '';
      if (r?.entityType === 'company') {
        if (r?.cnpj?.value) {
          subtitle = `CNPJ ${parseCnpjToDisplay(returnOnlyNumbers(r.cnpj.value))}`;
        } else if (r?.nipc?.value) {
          subtitle = `NIPC ${parseNipcToDisplay(returnOnlyNumbers(r.nipc.value))}`;
        }
      } else if (r?.entityType === 'person') {
        if (r?.cpf?.value) {
          subtitle = `CPF ${parseCpfToDisplay(returnOnlyNumbers(r.cpf.value))}`;
        } else if (r?.nif?.value) {
          subtitle = `NIF ${parseNifToDisplay(returnOnlyNumbers(r.nif.value))}`;
        }
      }

      const nameContent = (
        <div className="d-flex flex-column" style={{ minWidth: 0 }}>
          <span className="font-weight-semibold text-truncate">{r?.fullName || '-'}</span>
          {subtitle && <span className="text-muted text-truncate" style={{ fontSize: 12 }}>{subtitle}</span>}
        </div>
      );

      if (!flagSrc) return nameContent;

      return (
        <div className="d-flex align-items-flex-start" style={{ gap: 8 }}>
          <img
            src={flagSrc}
            alt={cc}
            style={{ width: 20, height: 14, flexShrink: 0, borderRadius: 2, marginTop: 2 }}
            onError={e => {
              e.target.style.display = 'none';
            }}
          />
          {nameContent}
        </div>
      );
    },
  };
}

export default fullNameColumn;
